module.exports = __webpack_public_path__ + "static/verimatrix-gray-880b0aae197311f8a28053b85cdcf527.png";